import { styled } from "styled-components";

export const FooterContainer = styled.footer`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  gap: 2rem;
  justify-content: center;
  border-top: 1px solid #18181b;
  min-height: 64px;
  padding: 0 2rem;
  background-color: #0e0e12;
  position: relative;
`;

export const Link = styled.a`
  color: #a1a1aa;
  font-family: Figtree;

  font-size: 12px;
  cursor: pointer;
  font-weight: 400;
  letter-spacing: -0.06px;

  &:hover {
    opacity: 0.65;
  }
`;
